<template lang="pug">
div.landing-page
  public-navbar(:use-primary-color="true")  
  v-container(fluid).px-0
    v-container.px-3
      //- Hero Section con Parallax Slider
      v-carousel.carousel-custom(
        v-model="currentSlide"
        height="220"
        cycle
        :show-arrows="false"
        :interval="9000"
        delimiter-icon="mdi-circle-small"
        :hide-delimiters="true"
      )
        template(v-slot:default)
          v-carousel-item(
            v-for="(slide, i) in heroSlides"
            :key="i"
            :src="slide.image"
            cover
            @click.stop="handleSlideClick($event, slide)"
            style="cursor: pointer;"
          )
            .carousel-gradient
            v-container(class="fill-height")
              v-row(
                class="fill-height"
                align="center"
                justify="center"
              )
                v-col(
                  cols="12"
                  sm="10"
                  md="8"
                  class="text-center"
                )
                  v-slide-y-transition
                    .hero-content(v-show="currentSlide === i")
                      h1.text-h5.text-sm-h4.font-weight-light.mb-2.white--text.text-left {{ slide.title }}
                      p.text-subtitle-2.text-sm-subtitle-1.mb-4.white--text.text-left {{ slide.description }}
      .carousel-controls.mt-4.text-center
        v-btn(
          v-for="(slide, i) in heroSlides"
          :key="i"
          icon
          small
          :color="currentSlide === i ? 'primary' : 'grey'"
          @click="currentSlide = i"
        )
          v-icon(size="12") mdi-circle
    v-container.px-6
      h2.text-h5.font-weight-medium.text-center.mb-8.primary--text ¿Qué querés hacer hoy?
      v-row(justify="center")
        v-col(
          v-for="(card, index) in sortedNavigationCards"
          :key="card.route"
          cols="6"
          sm="6"
          md="3"
          lg="auto"
          xl="auto"
          class="d-flex justify-center"
        )
          v-hover(v-slot="{ hover }")
            v-card(
              :class="{ 'elevation-6': hover, 'elevation-0': !hover }"
              class="navigation-card rounded-xl overflow-hidden"
              height="180"
              width="180"
              flat
              @click="navigateTo(card.route)"
              :ripple="false"
            )
              .card-inner.d-flex.flex-column.align-center.justify-center.py-4.h-100
                v-img(
                  :src="require(`@/assets/images/${card.image}.png`)"
                  height="80"
                  width="80"
                  contain
                  class="mb-0"
                )
                h3.text-subtitle-1.font-weight-medium.text-center.black--text {{ card.title }}
    //- Últimos Locales Añadidos
    v-container(class="latest-restaurants py-12  px-6")
      v-row
        v-col(cols="12")
          h2.text-h5.font-weight-normal.mb-6.primary--text Últimos Locales Añadidos
          v-slide-group(
            v-model="selectedLatest"
            class="pa-0"
            :show-arrows='false'
            center-active
          )
            v-slide-item(
              v-for="restaurant in latestRestaurants"
              :key="restaurant.id"
            )
              v-card(
                class="mr-4 mb-1 ml-1"
                width="300"
                @click="viewRestaurant(restaurant.urlSlug)"
              )
                v-img(
                  :src="restaurant.coverImage"
                  height="200"
                  cover
                )
                  .d-flex.justify-end.pa-2
                    v-btn.share-button(
                      icon
                      x-small
                      color="white"
                      elevation="1"
                      @click.stop="shareRestaurant($event, restaurant)"
                    )
                      v-icon(size="18") mdi-share-variant
                v-card-title.text-truncate {{ restaurant.name }}
                v-card-subtitle.text-truncate(v-if="restaurant.categories && restaurant.categories.length")
                  span(v-for="(category, index) in restaurant.categories" :key="typeof category === 'object' ? category._id : category")
                    | {{ getCategoryName(category) }}
                    span(v-if="index < restaurant.categories.length - 1") {{ ' • ' }}
                v-card-actions
                  v-btn(
                    v-if="restaurant.allowsReservations"
                    text
                    color="primary"
                    small
                    @click.stop="goToReservation(restaurant.urlSlug)"
                  )
                    v-icon(left) mdi-calendar-clock
                    | Reservar mesa
                  v-btn(
                    v-if="hasOrderOptions(restaurant)"
                    text
                    color="secondary"
                    small
                    @click.stop="goToOrder(restaurant.urlSlug)"
                  )
                    v-icon(left) mdi-food
                    | Pedir Comida
    //- Locales Más Populares
    v-container(fluid class="popular-restaurants py-6  px-6")
      v-row
        v-col(cols="12")
          v-container
            h2.text-h5.font-weight-normal.mb-6.primary--text 
              span Locales Más Populares
              v-chip(
                color="primary"
                class="ml-4"
                small
              ) TOP
            v-row
              v-col(
                v-for="restaurant in popularRestaurants"
                :key="restaurant.id"
                cols="12"
                sm="6"
                md="4"
              )
                v-card(
                  elevation="2"
                  class="h-100"
                  @click="viewRestaurant(restaurant.urlSlug)"
                )
                  v-img(
                    :src="restaurant.coverImage"
                    height="200"
                    cover
                  )
                    .d-flex.justify-end.pa-2
                      v-btn.share-button(
                        icon
                        x-small
                        color="white"
                        elevation="1"
                        @click.stop="shareRestaurant($event, restaurant)"
                      )
                        v-icon(size="18") mdi-share-variant
                  v-card-title
                    span {{ restaurant.name }}
                    v-spacer
                    v-chip(
                      color="success"
                      small
                    ) {{ restaurant.rating }}
                  v-card-subtitle.text-truncate(v-if="restaurant.categories && restaurant.categories.length")
                    span(v-for="(category, index) in restaurant.categories" :key="typeof category === 'object' ? category._id : category")
                      | {{ getCategoryName(category) }}
                      span(v-if="index < restaurant.categories.length - 1") {{ ' • ' }}
                  v-card-text.text-truncate {{ restaurant.description }}
                  v-card-actions
                    v-btn(
                      v-if="restaurant.allowsReservations"
                      text
                      color="primary"
                      small
                      @click.stop="goToReservation(restaurant.urlSlug)"
                    )
                      v-icon(left) mdi-calendar-clock
                      | Reservar mesa
                    v-btn(
                      v-if="hasOrderOptions(restaurant)"
                      text
                      color="secondary"
                      small
                      @click.stop="goToOrder(restaurant.urlSlug)"
                    )
                      v-icon(left) mdi-food
                      | Pedir Comida
    //- Sección "Sumá tu Restaurante"
    v-container(fluid class="restaurant-join-section pt-16 mt-6 px-6")
      v-row(justify="center" align="center")
        v-col(cols="12" md="6" class="text-center")
          h4.text-h5.font-weight-light.mb-2 ¿Tenés un restaurante?
          p.text-subtitle-2.font-weight-light Sumalo a la plataforma y llegá a miles de clientes
          v-btn(
            x-large
            color="secondary"
            @click="$router.push('/restaurant/register')"
          ) Sumar mi restaurante
          v-row(class="mt-12" justify="center")
            v-col(v-for="stat in statistics" :key="stat.value" cols="auto" class="text-center mx-4")
              h4.text-h5.font-weight-light {{ stat.value }}
              p.caption.text-center {{ stat.label }}
    //- Newsletter
    v-container(fluid class="newsletter-section py-16 mt-16  px-6")
      v-row(justify="center")
        v-col(cols="12" md="6" class="text-center")
          h2.text-h5.font-weight-bold.mb-4 ¡No te pierdas nuestras novedades!
          p.subtitle-2.mb-8 Suscribite para recibir las últimas noticias y ofertas especiales
          v-row(justify="center")
            v-col(cols="12" sm="8" md="6")
              v-form(ref="newsletterForm" v-model="isNewsletterValid")
                v-text-field(
                  v-model="newsletterEmail"
                  label="Tu email"
                  :rules="emailRules"
                  outlined
                  dense
                )
                v-btn(
                  color="primary"
                  block
                  :loading="isSubscribing"
                  :disabled="!isNewsletterValid"
                  @click="subscribeNewsletter"
                ) Suscribirme

    //- Chat Button Comentado temporalmente
    //- v-btn(
    //-   fab
    //-   large
    //-   color="green"
    //-   fixed
    //-   bottom
    //-   right
    //-   class="mb-3 mr-3"
    //- )
    //-   v-icon(color='white') mdi-whatsapp

</template>

<script>
  import { defineComponent } from 'vue'
  import { mapActions, mapState } from 'vuex'
  import PublicNavbar from '@/components/layout/PublicNavbar.vue'

  export default defineComponent({
    name: 'Landing',
    components: {
      PublicNavbar
    },
    data: () => ({
      currentSlide: 0,
      heroSlides: [
        // Los slides predeterminados se mostrarán solo mientras se cargan los anuncios
        {
          title: 'Los mejores restaurantes a un click',
          description: 'Descubrí una nueva experiencia gastronómica',
          buttonText: 'Explorar ahora',
          image: require('@/assets/images/hero-slide-1.svg'),
          action: 'pedir'
        },
        {
          title: 'Reservá en los mejores lugares',
          description: 'Asegurá tu mesa en los restaurantes más exclusivos',
          buttonText: 'Reservar mesa',
          image: require('@/assets/images/hero-slide-2.svg'),
          action: 'reservar'
        },
        {
          title: 'Eventos únicos te esperan',
          description: 'Participá de experiencias gastronómicas inolvidables',
          buttonText: 'Ver eventos',
          image: require('@/assets/images/hero-slide-3.svg'),
          action: 'eventos'
        }
      ],
      loadingAds: false,
      navigationCards: [
        {
          title: 'Pedir comida',
          description: 'Hacé tu pedido y te lo llevamos',
          route: '/pedir',
          image: 'pedir',
          order: 1
        },
        {
          title: 'Reservar mesa',
          description: 'Tu mesa asegurada',
          route: '/reservar',
          image: 'reservar2',
          order: 2
        },
        {
          title: 'Ver Eventos',
          description: 'Descubrí experiencias únicas',
          route: '/eventos',
          image: 'eventos',
          order: 3
        },
        {
          title: 'Leer noticias',
          description: 'Noticias y novedades',
          route: '/blog',
          image: 'blog',
          order: 4
        }
      ],
      searchQuery: '',
      isSearching: false,
      selectedLatest: null,
      statistics: [
        { value: '500+', label: 'Restaurantes' },
        { value: '50K+', label: 'Usuarios activos' },
        { value: '100K+', label: 'Pedidos realizados' }
      ],
      newsletterEmail: '',
      isNewsletterValid: false,
      isSubscribing: false,
      emailRules: [
        v => !!v || 'El email es requerido',
        v => /.+@.+\..+/.test(v) || 'El email debe ser válido'
      ]
    }),
    computed: {
      ...mapState({
        allLatestRestaurants: state => state.restaurant.latestRestaurants,
        allPopularRestaurants: state => state.restaurant.popularRestaurants,
        searchResults: state => state.restaurant.searchResults,
        searchSuggestions: state => state.restaurant.searchSuggestions,
        loading: state => state.restaurant.loading,
        defaultCity: state => state.restaurant.defaultCity,
        activeAds: state => state.advertisements.activeAdvertisements
      }),
      // Filtrar restaurantes activos como medida de seguridad adicional
      latestRestaurants() {
        return (this.allLatestRestaurants || []).filter(restaurant => restaurant.isActive !== false)
      },
      popularRestaurants() {
        return (this.allPopularRestaurants || []).filter(restaurant => restaurant.isActive !== false)
      },
      sortedNavigationCards() {
        return [...this.navigationCards].sort((a, b) => a.order - b.order)
      }
    },
    watch: {
      // Observar cambios en los anuncios activos
      activeAds: {
        handler(newAds) {
          if (newAds && newAds.length > 0) {
            this.updateHeroSlidesFromAds();
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions({
        fetchLatest: 'restaurant/fetchLatest',
        fetchPopular: 'restaurant/fetchPopular',
        search: 'restaurant/search',
        getSuggestions: 'restaurant/getSuggestions',
        fetchActiveAds: 'advertisements/fetchActiveAdvertisements'
      }),
      /**
       * Procesa los anuncios activos y actualiza los slides
       */
      updateHeroSlidesFromAds() {
        // Si hay anuncios activos, reemplazamos los slides predeterminados
        if (this.activeAds && this.activeAds.length > 0) {
          // Mapear los anuncios al formato de heroSlides
          const adSlides = this.activeAds.map(ad => ({
            _id: ad._id, // Guardar el id para registrar clics
            title: ad.title,
            description: ad.description,
            buttonText: ad.buttonText || 'Ver más',
            image: ad.image.url,
            targetUrl: ad.targetUrl,
            action: 'url' // Acción especial para URLs externas
          }))
          
          // Reemplazar los slides
          this.heroSlides = adSlides
          
          // Resetear el slide actual si estamos fuera de rango
          if (this.currentSlide >= adSlides.length) {
            this.currentSlide = 0
          }
        }
      },
      // Método para manejar el clic en un slide con control de propagación
      handleSlideClick(event, slide) {
        // Detener la propagación del evento para evitar doble clic
        event.stopPropagation()
        
        // Llamar al método que maneja la acción del slide
        this.handleSlideAction(slide)
      },
      
      // Método para manejar la acción del slide según su tipo
      handleSlideAction(slide) {
        switch (slide.action) {
          case 'pedir':
            this.$router.push('/pedir')
            break
          case 'reservar':
            this.$router.push('/reservar')
            break
          case 'eventos':
            this.$router.push('/eventos')
            break
          case 'url':
            // Nuevo tipo de acción para manejar URLs externas
            if (slide._id) {
              // Registrar el clic solo si es un anuncio real (tiene _id)
              this.$store.dispatch('advertisements/registerAdClick', slide._id)
            }
            // Abrir la URL en la misma pestaña
            window.location.href = slide.targetUrl
            break
          default:
            this.$router.push('/')
        }
      },
      navigateTo(route) {
        this.$router.push(route)
      },
      async handleSearch() {
        if (!this.searchQuery) return
        this.isSearching = true
        try {
          // Aquí iría la llamada a la API
          await this.searchRestaurants(this.searchQuery)
        } finally {
          this.isSearching = false
        }
      },
      async getUserLocation() {
        try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject)
          })
          await this.searchNearby({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          })
        } catch (error) {
          console.error('Error getting location:', error)
        }
      },
      viewRestaurant(id) {
        this.$router.push(`/r/${id}`)
      },
      getCategoryName(category) {
        // Si category es un objeto (ya poblado desde el backend), devolver su nombre directamente
        if (category && typeof category === 'object' && category.name) {
          return category.name;
        }
        
        // Si es solo un ID y tenemos las categorías, buscar en la lista
        if (this.categories) {
          const categoryObj = this.categories.find(cat => cat._id === category);
          if (categoryObj) return categoryObj.name;
        }
        
        return '';
      },
      async subscribeNewsletter() {
        if (!this.$refs.newsletterForm.validate()) return
        
        this.isSubscribing = true
        try {
          await this.$store.dispatch('newsletter/subscribe', this.newsletterEmail)
          this.$toast.success('¡Gracias por suscribirte!')
          this.newsletterEmail = ''
        } catch (error) {
          this.$toast.error('Hubo un error al suscribirte. Por favor, intentá nuevamente.')
        } finally {
          this.isSubscribing = false
        }
      },
      goToReservation(urlSlug) {
        this.$router.push(`/r/${urlSlug}/reservas`)
      },
      hasOrderOptions(restaurant) {
        return restaurant.salesMethods && (restaurant.salesMethods.takeaway || restaurant.salesMethods.delivery)
      },
      goToOrder(urlSlug) {
        this.$router.push(`/r/${urlSlug}`)
      },
      shareRestaurant(e, restaurant) {
        // Evitar la navegación al restaurante cuando se presiona el botón
        e.stopPropagation()
        e.preventDefault()
        
        // Construir la URL completa para compartir
        const restaurantUrl = `${window.location.origin}/r/${restaurant.urlSlug}`
        
        // Copiar al portapapeles
        navigator.clipboard.writeText(restaurantUrl)
          .then(() => {
            // Mostrar mensaje de éxito
            this.showNotification({
              text: 'URL del restaurante copiada al portapapeles',
              color: 'success'
            })
          })
          .catch(err => {
            console.error('Error al copiar URL: ', err)
            this.showNotification({
              text: 'No se pudo copiar la URL. Intentá nuevamente.',
              color: 'error'
            })
          })
      },
    },
    async created() {
      try {
        await Promise.all([
          this.fetchLatest(),
          this.fetchPopular(),
          this.fetchActiveAds()
        ]);
        
        // Actualizar los slides con los anuncios activos
        this.updateHeroSlidesFromAds();
      } catch (error) {
        console.error('Error fetching restaurants:', error);
      }
    }
  })
</script>

<style scoped>
  /* Estilos para la cuadrícula 2x2 */
  .navigation-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 400px;
  }
  
  .navigation-row {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  
  .navigation-cell {
    display: inline-block;
  }
  
  .restaurant-join-section {
    background-size: cover;
    background-position: center;
    color: #000;
  }
  .popular-restaurants {
    background: #f0f0f0;
  }
  .newsletter-section {
    background-color: #f5f5f5;
  }

  .v-slide-group {
    .v-slide-item {
      .v-card {
        transition: transform 0.2s;
        &:hover {
          transform: translateY(-4px);
        }
      }
    }
  }
  header.v-sheet.theme--light.elevation-0.v-toolbar.v-app-bar.v-app-bar--fixed {
    background: #f34848 !important;
}
  .navigation-card-col {
    padding: 0px!important;
    &:first-child {
      padding: 0 5px 5px 0 !important;
    }
    &:nth-child(3) {
      padding: 0 5px 5px 0 !important;
    }
  }
  .landing-page {
    background: #fff;
  }
  .navigation-card {
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    color: #fff;
    background: #f2f2f2 !important;
    height: 100%;
    border-radius: 15px!important;
    border: 0px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: currentColor;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
  }

  .v-card.on-hover {
    background: linear-gradient(to bottom right, rgb(248, 64, 64), rgba(247, 63, 63, 0.95));
  }

  .carousel-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .hero-content {
    position: relative;
    z-index: 1;
    padding: 1rem;
    max-width: 100%;
  
    @media (min-width: 600px) {
      padding: 2rem;
      max-width: 80%;
    }
  }

  .v-carousel {
    box-shadow: none;
    margin-top: 60px;
    border-radius: 15px;
  }

  .v-carousel__item {
    filter: brightness(0.9);
    transition: filter 0.6s ease;
  }

  .v-carousel__item--active {
    filter: brightness(1);
  }

  .v-btn {
    letter-spacing: 1px;
    text-transform: none !important;
    transition: all 0.3s ease;
  }

  .v-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.18), 0 5px 5px rgba(0, 0, 0, 0.12) !important;
  }

  .hero-button {
    height: 36px !important;
    min-width: auto !important;
    padding: 0 16px !important;
    border-radius: 4px !important;
  
    @media (min-width: 600px) {
      height: 44px !important;
      padding: 0 24px !important;
    }
  }

  .carousel-custom {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
  }

  .carousel-controls {
    margin-top: 16px;
  }

  .carousel-controls .v-btn {
    margin: 0 4px;
  }

  .v-slide-group {
    .v-slide-item {
      .v-card {
        transition: transform 0.2s;
        &:hover {
          transform: translateY(-4px);
        }
      }
    }
  }
  .wide-card {
    flex-direction: row !important;
    padding: 0 16px;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .navigation-card:not(.wide-card) {
    flex-direction: column;
    justify-content: center;
    text-align: center;

    .card-content {
      align-items: center;
    }
  }

  .navigation-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 0px solid #e0e0e0;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 16px;
    text-align: center;
    
    .card-content {
      h3 {
        transition: color 0.3s ease;
      }
      
      .v-icon {
        transition: transform 0.3s ease;
      }
    }
    
    &:hover {
      .card-icon-container {
        .v-icon {
          transform: scale(1.1);
        }
      }
      
      .card-content {
        h3 {
          color: #1976d2 !important;
        }
        
        .v-icon {
          transform: translateX(4px);
        }
      }
    }
  }
  
  @media (max-width: 600px) {
    .navigation-card-col {
      padding: 8px !important;
    }
  }
</style>